import { APIProvider } from '@vis.gl/react-google-maps';
import { Map } from '@vis.gl/react-google-maps';
import cx from 'clsx';
import React, { useState } from 'react';

import { ReactComponent as DoubleArrowSvg } from '@assets/svg/double-arrow.svg';

import Header from '@components/common/Header/Header';
import Loader from '@components/common/Loader/Loader';
import Button from '@components/uikit/Button/Button';

import { useDebouncedValue } from '@hooks/useDebouncedValue';
import useTranslation from '@hooks/useTranslation';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import AssetsList from './components/AssetsList/AssetsList';
import FilterPanel from './components/FilterPanel/FilterPanel';
import GoogleMapMarkers from './components/GoogleMapMarkers/GoogleMapMarkers';
import GpsTrackerBlock from './components/GpsTrackersBlock/GpsTrackersBlock';
import { useGPSAssetsQuery } from './services/useGPSAssetsQuery';
import {
  selectAssetTableSorting,
  selectFilterAssetStatus,
  selectSearchValue,
} from './store/useAssetTrackerStore';
import style from './style.module.scss';

const defaultMapCenter = { lat: 39.10744089786368, lng: -84.50641249935421 };

const GPSAssetTracking = () => {
  const { t } = useTranslation();

  const [showTrackers, setShowTrackers] = useState(false);

  const { data: profileData } = useUserProfileQuery();

  const searchValue = selectSearchValue();
  const filterAssetStatus = selectFilterAssetStatus();
  const sorting = selectAssetTableSorting();

  const customerMapId = `${profileData?.customer?.name}MapId`;

  const [debouncedValue] = useDebouncedValue(searchValue, 500);

  const { data: assetsData, isFetching } = useGPSAssetsQuery({
    query: debouncedValue,
    sorting,
    filtersStatus: filterAssetStatus,
  });

  return (
    <APIProvider apiKey={APP_GOOGLE_MAPS_API_KEY} region="US" language="en">
      <div className={style.page}>
        <Header
          title={t('GPS Asset Tracking')}
          showLogo={true}
          headerRightComponent={
            <Button
              text={showTrackers ? t('Hide GPS Tracker List') : t('View GPS Tracker List')}
              onClick={() => setShowTrackers(!showTrackers)}
              type="secondary"
              rightElement={
                <DoubleArrowSvg
                  className={cx(style.trackersArrow, { [style.trackersArrowTop]: showTrackers })}
                />
              }
            />
          }
        />
        {showTrackers && <GpsTrackerBlock />}
        <div className={style.mainContent}>
          <FilterPanel />
          <AssetsList assetList={assetsData?.list} isLoading={isFetching} />
          <div className={style.mapWrapper}>
            <Map
              mapId={customerMapId}
              defaultCenter={defaultMapCenter}
              defaultZoom={11}
              minZoom={3}
              gestureHandling={'greedy'}
              disableDefaultUI={true}
              zoomControl={true}
              restriction={{
                latLngBounds: { north: 85, south: -85, west: -180, east: 180 },
                strictBounds: false,
              }}
            >
              {!isFetching ? <GoogleMapMarkers assetMarkers={assetsData?.assetMapMarkers} /> : <Loader />}
            </Map>
          </div>
        </div>
      </div>
    </APIProvider>
  );
};

export default GPSAssetTracking;
